import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/erp/get-stock-technician'

export const get = async (queryParam) => {
  const params = {
    email: queryParam?.email || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  return response
}
